import { ChangeDetectionStrategy, Component, TemplateRef, inject } from '@angular/core';
import { LanguageSelectorBase } from '../language-selector.base';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { Language } from '@fgb/core';

@Component({
  selector: 'fgbcl-language-selector-with-flag',
  templateUrl: './language-selector-with-flag.component.html',
  styleUrl: './language-selector-with-flag.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LanguageSelectorWithFlagComponent extends LanguageSelectorBase {
  	screenType = ScreenType;
	selectedLanguage: Language | undefined = this.currentLanguage();
	private offcanvasService = inject(NgbOffcanvas);

	open(content: TemplateRef<any>) {
		this.offcanvasService.open(content, { panelClass: 'language-select-v2-offcanvas', position: 'bottom' });
	}
}
